var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('img',{staticStyle:{"width":"100%","height":"auto"},attrs:{"src":"/images/Rewards-BC.jpg"}})])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }